import { registerPlugin, PluginListenerHandle } from "@capacitor/core";

export interface StepCounterPlugin {
  isAvailable(): Promise<{ available: boolean; hasPermission: boolean }>;
  requestPermission(): Promise<{ granted: boolean }>;
  start(): Promise<{ started: boolean }>;
  stop(): Promise<{ stopped: boolean }>;
  getSteps(): Promise<{ steps: number }>;
  addListener(
    event: "stepUpdate",
    listener: (data: { steps: number; totalSensorSteps: number }) => void,
  ): Promise<PluginListenerHandle>;
}

export const StepCounter = registerPlugin<StepCounterPlugin>("StepCounter", {
  web: {
    isAvailable: async () => ({ available: false, hasPermission: false }),
    requestPermission: async () => ({ granted: false }),
    start: async () => ({ started: false }),
    stop: async () => ({ stopped: false }),
    getSteps: async () => ({ steps: 0 }),
    addListener: async () => ({
      remove: async () => {},
    } as unknown as PluginListenerHandle),
  },
});
